export enum typeOfEventEnum {
  screen_view = 'screen_view',
  alert = 'alert',
  click = 'click',
}

export enum PathUrlEnum {
  LOGIN = '/credito/formulario/financiamento-imobiliario/web-proprietario-login',
  
  PROPRIETARIO_LISTA_FORMS = '/credito/formulario/financiamento-imobiliario/web-proprietario-lista-forms',
  PROPRIETARIO_ERRO = '/credito/formulario/financiamento-imobiliario/web-proprietario-erro',
  PROPRIETARIO_DIVISAO_IMOVEL = '/credito/formulario/financiamento-imobiliario/web-proprietario-divisao-imovel',
  PROPRIETARIO_FORMS_ENVIADOS = '/credito/formulario/financiamento-imobiliario/web-proprietario-forms-enviados',
  PROPRIETARIO_FORMS_JA_PREENCHIDOS = '/credito/formulario/financiamento-imobiliario/web-proprietario-ja-preenchido',

  PROPRIETARIO_PF_DADOS_PESSOAIS = '/credito/formulario/financiamento-imobiliario/web-proprietario-pf-dados-pessoais',
  PROPRIETARIO_PF_DADOS_CONJUGE = '/credito/formulario/financiamento-imobiliario/web-proprietario-pf-dados-pessoais-conjuge',
  PROPRIETARIO_PF_DADOS_PAGAMENTO = '/credito/formulario/financiamento-imobiliario/web-proprietario-pf-dados-pagamento',
  PROPRIETARIO_PF_RESUMO = '/credito/formulario/financiamento-imobiliario/web-proprietario-pf-resumo',
  
  PROPRIETARIO_PJ_DADOS_EMPRESA = '/credito/formulario/financiamento-imobiliario/web-proprietario-pj-dados-empresa',
  PROPRIETARIO_PJ_DADOS_REPRESENTANTES = '/credito/formulario/financiamento-imobiliario/web-proprietario-pj-dados-representantes',
  PROPRIETARIO_PJ_DADOS_PAGAMENTO = '/credito/formulario/financiamento-imobiliario/web-proprietario-pj-dados-pagamento',
  PROPRIETARIO_PJ_SALVAR_FORM = '/credito/formulario/financiamento-imobiliario/web-proprietario-pj-resumo',
}

export enum EventEnum {
  BTN_VOLTAR = 'btn:voltar',
  BTN_BUSCAR = 'btn:buscar',
  BTN_CONTINUAR = 'btn:continuar',
  BTN_FINALIZAR_PREENCHIMENTO = 'btn:finalizarpreenchimento',
  BTN_IR_PARA_TELA_INICIAL = 'btn:irparatelainicial',
  BTN_TENTAR_NOVAMENTE = 'btn:tentarnovamente',
  BTN_SALVAR_FORMULARIO = 'btn:salvarformulario'
}
